import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    contactNo: "",
    email: "",
    address: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("✅ तुमचा संदेश यशस्वीरित्या पाठवला गेला आहे!");
    setFormData({
      fullName: "",
      contactNo: "",
      email: "",
      address: "",
      message: "",
    });
  };

  /* ================= Contact Info Section Styles ================= */
  const sectionStyles = {
    container: {
      maxWidth: "1100px",
      margin: "50px auto",
      padding: "10px",
    },
    title: {
      textAlign: "center",
      marginBottom: "30px",
      color: "#b91c1c",
      fontSize: "32px",
      fontWeight: "700",
    },
    row: {
      display: "flex",
      justifyContent: "center",
      gap: "25px",
      flexWrap: "wrap",
    },
    card: {
      padding: "25px",
      borderRadius: "12px",
      textAlign: "center",
      width: "300px",
      boxShadow: "0 5px 20px rgba(0,0,0,0.15)",
      color: "white",
      fontSize: "18px",
      fontWeight: "500",
    },
  };

  const ContactSection = () => (
    <div style={sectionStyles.container}>
      <h2 style={sectionStyles.title}>संपर्क माहिती</h2>

      <div style={sectionStyles.row}>
        {/* Address */}
        <div style={{ ...sectionStyles.card, backgroundColor: "#0d6efd" }}>
          <h3>📍 पत्ता</h3>
          <p style={{ marginTop: "10px" }}>
            ग्रामपंचायत  आवळगांव <br />
            पं. स. ब्रम्हपुरी, जि. चंद्रपूर <br />
            महाराष्ट्र – 441206
          </p>
        </div>

        {/* Phone */}
        <div style={{ ...sectionStyles.card, backgroundColor: "#198754" }}>
          <h3>📞 फोन</h3>
          <p style={{ marginTop: "10px" }}>
            7972382206 | 9881245686
          </p>
          <p>
            कार्यालयीन वेळ <br />
            सकाळी ९:०० ते दुपारी ५:००
          </p>
        </div>

        {/* Email */}
        <div
          style={{
            ...sectionStyles.card,
            backgroundColor: "#ffc107",
            color: "#000",
          }}
        >
          <h3>✉ ई-मेल</h3>
          <p style={{ marginTop: "10px" }}>
            gpawalgaon3403@gmail.com
          </p>
        </div>
      </div>
    </div>
  );

  /* ================= Main Page Styles ================= */
  const styles = {
    main: {
      fontFamily: "Poppins, sans-serif",
      background: "linear-gradient(135deg, #e8f5e9, #ffffff)",
    },
    container: {
      maxWidth: "800px",
      margin: "30px auto",
      backgroundColor: "#fff",
      padding: "40px",
      borderRadius: "20px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
      borderTop: "6px solid #16a34a",
    },
    heading: {
      fontSize: "30px",
      color: "#14532d",
      fontWeight: "700",
      textAlign: "center",
      marginBottom: "10px",
    },
    subheading: {
      textAlign: "center",
      color: "#666",
      marginBottom: "25px",
    },
    label: {
      display: "block",
      marginBottom: "5px",
      fontWeight: "600",
    },
    input: {
      width: "100%",
      padding: "12px",
      borderRadius: "8px",
      border: "2px solid #bbf7d0",
      marginBottom: "18px",
      fontSize: "15px",
    },
    textarea: {
      width: "100%",
      padding: "12px",
      borderRadius: "8px",
      border: "2px solid #bbf7d0",
      marginBottom: "18px",
      fontSize: "15px",
    },
    button: {
      width: "100%",
      padding: "12px",
      backgroundColor: "#16a34a",
      border: "none",
      borderRadius: "8px",
      color: "white",
      fontWeight: "700",
      fontSize: "16px",
      cursor: "pointer",
    },

    /* ===== Map Styles ===== */
    mapSection: {
      margin: "60px auto",
      padding: "40px 20px",
      background: "linear-gradient(135deg, #f1f8e9, #ffffff)",
      borderTop: "4px solid #2e7d32",
      textAlign: "center",
    },
    mapTitle: {
      fontSize: "28px",
      fontWeight: "700",
      color: "#1b5e20",
      marginBottom: "8px",
    },
    mapSubtitle: {
      fontSize: "16px",
      color: "#555",
      marginBottom: "25px",
    },
    mapBox: {
      maxWidth: "1000px",
      margin: "auto",
      borderRadius: "18px",
      overflow: "hidden",
      border: "3px solid #81c784",
      boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
    },
    iframe: {
      width: "100%",
      height: "420px",
      border: 0,
    },
  };

  return (
    <div style={styles.main}>
      {/* Contact Info Cards */}
      <ContactSection />

      {/* Contact Form */}
      <div style={styles.container}>
        <h1 style={styles.heading}>📞 संपर्क करा</h1>
        <p style={styles.subheading}>
          तुमचे प्रश्न, सूचना आणि अभिप्राय आमच्यासाठी महत्त्वाचे आहेत.
        </p>

        <form onSubmit={handleSubmit}>
          <label style={styles.label}>पूर्ण नाव</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <label style={styles.label}>संपर्क क्रमांक</label>
          <input
            type="tel"
            name="contactNo"
            value={formData.contactNo}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <label style={styles.label}>ई-मेल</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            style={styles.input}
          />

          <label style={styles.label}>पत्ता</label>
          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
            rows="2"
            style={styles.textarea}
          />

          <label style={styles.label}>संदेश</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows="3"
            style={styles.textarea}
          />

          <button type="submit" style={styles.button}>
            ✉️ संदेश पाठवा
          </button>
        </form>
      </div>

      {/* ===== Village Map Section ===== */}
      <section style={styles.mapSection}>
        <h2 style={styles.mapTitle}>📍 ग्रामपंचायत  आवळगांव – स्थान</h2>
        <p style={styles.mapSubtitle}>
          तालुका ब्रम्हपुरी, जिल्हा चंद्रपूर
        </p>

        <div style={styles.mapBox}>
          <iframe
            title="Awalgaon Map"
            src="https://www.google.com/maps?q=20.3912377,79.9472502&z=17&output=embed"
            loading="lazy"
            style={styles.iframe}
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default Contact;
